import { makeStyles } from '@material-ui/core';

export const useSequencesPreviewStyles = makeStyles(() => ({
  strikedText: {
    textDecoration: 'line-through'
  }
}));
